import React from 'react'
import {Container, Bubble} from "./ChatBubble"
import {connect} from "react-redux"
import {setActiveImage, setItemBlur} from "../actions"
import Text from "../../common/components/Text"
import ClickIcon from "../images/ClickIcon"
import styled from "styled-components"

const BubbleContainer = styled(Bubble)`
  position: relative;
  padding: ${10/18}rem;
`

const Image = styled.img`
  max-width: 100%;
  max-height: 33vh;
  cursor: pointer;
  image-rendering: -webkit-optimize-contrast;
  ${props => props.blur && `
    opacity: 0.1;
    filter: blur(10px);`}
`

const Video = Image.withComponent('video')

const HintText = Text.withComponent('div').extend.attrs({
  color: 'primary',
  size: 'bodySmall'
})``

const Hint = styled.div`
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const MediaWrapper = styled.div`
  overflow: hidden;
`

const MediaBubble = ({media, imageClick, ...props}) => (
  <Container onClick={imageClick} question className='bubble-question'>
    <BubbleContainer question>
      {props.blur && <Hint>
        <ClickIcon />
        <HintText>Click to view</HintText>
      </Hint>}
      <MediaWrapper>
        {(media.split('.').pop()==='mp4') ?
        <Video {...props} autoPlay loop muted controls name="media">
          <source src={media} type="video/mp4" />
        </Video> :
        <Image {...props} src={media} alt="" />}
      </MediaWrapper>
    </BubbleContainer>
  </Container>
)

const mapDispatchToProps = (dispatch, ownProps) => ({
  imageClick: () => {
    if (ownProps.blur) {
      dispatch(setItemBlur(false, ownProps.index))
    } else {
      dispatch(setActiveImage(ownProps.media))
    }
  }
})

const MediaBubbleWrapper = connect(undefined, mapDispatchToProps)(MediaBubble)

export {MediaBubbleWrapper as default, MediaBubble}



// WEBPACK FOOTER //
// ./assets/interview/components/MediaBubble.js